import { Component, Input } from '@angular/core';
import { Product } from '@spartacus/core';

@Component({
  selector: 'add-to-wish-list',
  templateUrl: './product-add-to-wish-list.component.html',
  styleUrl: './product-add-to-wish-list.component.scss',
  standalone: false,
})
export class ProductAddToWishListComponent {
  @Input() product!: Product;

  isFavorite = false;

  toggleFavorite() {
    this.isFavorite = !this.isFavorite;
  }
}
